import { g as __rest, b as __assign } from '../../../../../_tslib-7a01aab4.js';
import React from 'react';

var LogoImg = function (_a) {
    var src = _a.src, children = _a.children, _b = _a.alt, alt = _b === void 0 ? '' : _b, rest = __rest(_a, ["src", "children", "alt"]);
    return (React.createElement("div", __assign({ className: 'pgc-logo-container' }, rest),
        React.createElement("img", { src: src, alt: alt }),
        children));
};

export { LogoImg };
